import * as React from "react";
const logo = require("./AeliteZLogoWriteRed.gif");
const logo2 = require("./Logoname.png");
export default function ModalLoader() {
  return (
    <>  
      <div className="modal fade show loader-modal">
        <div style={{ textAlign: "center" }}>
          {/* <img
            src={logo}
            alt="loader"
            style={{
              width: "50px",
              height: "50px",
              marginBottom: "10px",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          /> */}

          <img
            src={logo2}
            alt="Aelitez Logo"
            style={{
              width: "120px",
              height: "25px",
            }}
          />
        </div>
      </div>

      <div
        className="modal-backdrop fade show"
        style={{ opacity: ".03" }}
      ></div>
    </>
  );
}
